/**
 * Formats a URL by adding https:// if no protocol is specified
 * @param {string} url - The URL to format
 * @returns {string} - The formatted URL with protocol
 */
export const formatUrl = (url) => {
  if (!url || typeof url !== 'string') {
    return url;
  }

  // Trim whitespace
  const trimmedUrl = url.trim();
  
  // If URL is empty, return as is
  if (!trimmedUrl) {
    return trimmedUrl;
  }

  // Check if URL already has a protocol (http:// or https://)
  const hasProtocol = /^https?:\/\//i.test(trimmedUrl);
  
  if (hasProtocol) {
    return trimmedUrl;
  }

  // Add https:// if no protocol is present
  return `https://${trimmedUrl}`;
};

/**
 * Validates if a URL is properly formatted
 * @param {string} url - The URL to validate
 * @returns {boolean} - True if URL is valid, false otherwise
 */
export const isValidUrl = (url) => {
  if (!url || typeof url !== 'string') {
    return false;
  }

  const formattedUrl = formatUrl(url);
  
  try {
    new URL(formattedUrl);
    return true;
  } catch {
    return false;
  }
};
